<template>
  <div>
    <TableSimple
        :fields="fields"
        :items="files"
        :loading="isLoading"
        :text-empty="$t('ordemResultado.modal.file_detail.empty')"
    >
      <template v-slot:cell(url)="{item, toggleDetails}">
        <p class="btn btn-link m-0" @click="toggleDetails()">{{ item.url.split('/').pop() }}</p>
      </template>
      <template v-if="hasPerfil('root')" v-slot:cell(resend)="{item}">
        <b-overlay v-if="isReadyToResend(item)" :show="sending">
          <b-button variant="link" :title="$t('ordemResultado.modal.file_detail.reenviar_arquivo')" @click="resend(item)" v-b-tooltip pill>Reenviar</b-button>
        </b-overlay>
      </template>
      <template v-slot:row-details="{item}" class="bg-gray-200">
        <FilesContent :file="item"/>
      </template>
    </TableSimple>
  </div>
</template>

<script>
import {hasPerfil} from "@/acl";
import OrderRepository from "@/repositories/vns/OrderRepository";
import {mapActions, mapGetters} from "vuex";
import TableSimple from "@/components/TableSimple";
import FilesContent from "@/pages/vns/observation/FilesContent";
import FileRepository from "@/repositories/monitorExams/FileRepository";

export default {
  name: "FilesDetail",
  components: {FilesContent, TableSimple},
  props: {
    typeTransaction: {
      type: String
    },
    id: {
      type: String
    }
  },
  computed: {
    ...mapGetters({
      files_storage: 'file/all',
      loading: 'file/isLoading',
      recipient: 'recipient/current'
    }),
    isLoading() {
      return this.files.length === 0 && this.loading
    },
    vnsName() {
      if (this.recipient) {
        let transactions
        if (Array.isArray(this.recipient)) {
          transactions = this.recipient.filter(r => r.orders.length > 0 || r.reports.length > 0)
          transactions = [...transactions[0].orders, ...transactions[0].reports]
        }
        if (typeof this.recipient === 'object') {
          if (this.recipient.orders && this.recipient.reports) {
            transactions = [...this.recipient.orders, ...this.recipient.reports]
          }
        }

        const transaction = transactions.find(t => t.vns)
        return transaction.vns
      }
      return null
    },
    files() {
      if (this.files_storage && this.files_storage.length > 0) {
        return this.files_storage.filter(f => f.fileable_id === this.id)
      }

      return []
    },
  },
  data() {
    return {
      fields: [
        {key: 'url', label: this.$t('ordemResultado.modal.file_detail.arquivo'), sortable: true},
        {key: 'stage', label: this.$t('ordemResultado.modal.file_detail.etapa'), sortable: true},
        {key: 'resend', label: this.$t('ordemResultado.modal.file_detail.reenviar')}
      ],
      sending: false,
      isLoadingFiles: false,
      contents: []
    }
  },
  methods: {
    ...mapActions([
      'file/listOrderFiles',
      'file/listReportFiles',
      'recipient/listOrders',
      'recipient/listReports'
    ]),
    hasPerfil(perfil) {
      return hasPerfil(perfil)
    },
    async loadTransactions () {
      if (this.recipient instanceof Array) {
        this.recipient.map(async r => {
          this['recipient/listOrders'](r.id)
          this['recipient/listReports'](r.id)
        })
      }

      if (!this.recipient instanceof Array){
        await this['recipient/listOrders'](this.recipient.id)
        await this['recipient/listReports'](this.recipient.id)
      }
    },
    loadFiles() {
      if (this.typeTransaction === 'Order') {
        this['file/listOrderFiles'](this.id)
      }

      if (this.typeTransaction === 'Report') {
        this['file/listReportFiles'](this.id)
      }
    },
    isReadyToResend(item) {
      return item.stage.includes('Result in') || item.stage.includes('Order in') || item.stage.includes('Resultado Recebido') || item.stage.includes('Ordem Recebida') || item.stage.includes('Resultado recibido') || item.stage.includes('Orden recibida') 
    },
    async resend(item) {
      this.sending = true

      try {
        let fileContent = null
        let fileName = item.url.split('/').pop()

          await FileRepository.getContentOfFile({fileUrl: item.url})
            .then(async responseFile => {
              fileContent = responseFile.data.content
            }).catch(() => {
              this.$snotify.error(this.$t('ordemResultado.messages.file_error'))
            })

        const resolve = async () => {
          this.$snotify.success(this.$t('ordemResultado.messages.resend.success'))
          this.$store.commit('file/setAll', [], {root: true})

          await this.loadTransactions()
          this.loadFiles()
        }
        const reject = () => {
          this.$snotify.error(this.$t('ordemResultado.messages.resend.error'))
        }

        if (this.typeTransaction === 'Order') {
          await OrderRepository.sendOrder({
            device_name: this.vnsName,
            filename: fileName,
            order_content: fileContent
          }).then(resolve)
              .catch(reject)
        }

        if (this.typeTransaction === 'Report') {
          await OrderRepository.sendReport({
            device_name: this.vnsName,
            filename: fileName,
            report_content: fileContent
          }).then(resolve)
              .catch(reject)
        }

      } catch (e) {console.error(e)}

      this.sending = false
    }
  },
  watch: {
    id(oldval, newval) {
      this.loadFiles()
    }
  },
  mounted() {
    if (this.files.length === 0) {
      this.loadFiles()
    }
  }
}
</script>
